import React, { useRef } from 'react'
/*import { loadAd } from '@/lib/cms/cms'
import Script from 'next/script'*/
import NoSsr from '@mui/material/NoSsr'
import getEnvVar from '@/lib/getEnvVar'
import { Box, useTheme } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'

export enum IdFormat {
  '728x90' = '1977672',
  '300x250' = '1977673',
}

/*export const useLoadScripts = scripts => {
  const scriptsLoaded = useRef(false)
  if (typeof window !== 'undefined' && !scriptsLoaded.current) {
    scripts.forEach(script => {
      const urlScript = `<script type="text/javascript" src="${script}"></script>`
      const element = document.createElement('script')
      //  element.src = script
      element.text = `document.write('${urlScript}');`
      element.async = true
      element.type = 'text/javascript'
      const position = document.querySelector('body')
      position.appendChild(element)
      return () => {
        position.removeChild(element)
      }
    })
    scriptsLoaded.current = true
  }
  return null
}*/
type Props = {
  idFormatBannerCms?: IdFormat
  sxBox?: any
}
const CMS: React.FC<Props> = ({ idFormatBannerCms = IdFormat['728x90'], sxBox = {} }) => {
  /* const src =
    'https://adx.adform.net/adx/?mid=1977672&eids=eyJmaXJzdHBhcnR5aWQiOnsieW91cl91c2VyX2lkIjpbMV19fQ==&rnd=%CACHEBUSTER%&mkv=loggue:,profession:,specialite:,contexte'

  // useLoadScripts([src])
  useEffect(() => {
    if (typeof window !== 'undefined') {
      // loadAd('your_user_id', idFormatBannerCms)
      //loadAd('your_user_id', IdFormat['300x250'])
    }
  }, [])*/

  /* useEffect(() => {
    const aScript = document.createElement('script')
    aScript.type = 'text/javascript'
    aScript.src =
      'https://adx.adform.net/adx/?mid=1977672&eids=eyJmaXJzdHBhcnR5aWQiOnsieW91cl91c2VyX2lkIjpbMV19fQ==&rnd=%CACHEBUSTER%&mkv=loggue:,profession:,specialite:,contexte'

    document.body.appendChild(aScript)
    aScript.onload = () => {}
  }, [])*/

  //tc.src = '${src}';

  /*return (
    <NoSsr>
      <div>
        insert script
        <script
          dangerouslySetInnerHTML={{
            __html: `
            (function() {
              var tc = document.createElement('script');
              tc.type = 'text/javascript';
              tc.src = '${src}';
              document.body.appendChild(tc)
            })();
          `,
          }}
        />
        <Script src={src} />
        script 1
        <script
          type="text/javascript"
          src="https://adx.adform.net/adx/?mid=1977672&eids=eyJmaXJzdHBhcnR5aWQiOnsieW91cl91c2VyX2lkIjpbMV19fQ==&rnd=%CACHEBUSTER%&mkv=loggue:,profession:,specialite:,contexte"
        ></script>
        script end
      </div>
    </NoSsr>
  )*/
  const theme = useTheme()
  if (getEnvVar('APP_ENV') === 'production') {
    return null
  }
  const iframeRef = useRef<HTMLIFrameElement>(null)
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const returnChangePage = () => {
    if (iframeRef?.current) {
      // iframeRef.current.style.height = `${iframeRef.current.contentWindow.document.body.scrollHeight}px`
      // iframeRef.current.style.width = `${iframeRef.current.contentWindow.document.body.scrollWidth}px`
    }
  }

  return (
    <NoSsr>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignContent: 'center',
          alignItems: 'center',
          ...sxBox,
        }}
      >
        <Box
          id="script-container"
          sx={{
            marginBottom: { xs: 0, md: 1 },
          }}
        >
          <iframe
            ref={iframeRef}
            id="iframe"
            title="iframe"
            style={{
              border: 0,
              maxHeight:
                isMobile && idFormatBannerCms == IdFormat['728x90']
                  ? 50
                  : isMobile
                    ? 150
                    : idFormatBannerCms == IdFormat['728x90']
                      ? 90
                      : 250,
              height:
                isMobile && idFormatBannerCms == IdFormat['728x90']
                  ? 50
                  : isMobile
                    ? 150
                    : idFormatBannerCms == IdFormat['728x90']
                      ? 90
                      : 250,
              maxWidth: isMobile ? '100%' : idFormatBannerCms == IdFormat['728x90'] ? 728 : 300,
            }}
            allowFullScreen
            width="100%"
            height="100%"
            // @ts-ignore
            scrolling="no"
            src={idFormatBannerCms == IdFormat['728x90'] ? '/cms/large.html' : '/cms/square.html'}
            onLoad={returnChangePage}
          />
        </Box>
      </Box>
    </NoSsr>
  )
}

export default CMS
